import { useEffect, useState } from "react";
import Header from "../Header/header";
import Footer from "../Footer/footer";
import "./layoutBlog.css";

import KSLiveExitIntentPopup from "../KSLivePopup/ExitInentKSLivePopup";
import LeadActivityTracker from "../LeadActivityTracker";

const Layout = (props) => {
  const [showPopup, setShowPopup] = useState(false);
  // Exit Intent popup implementation
  useEffect(() => {
    const handleMouseOut = (e) => {
      if (e.clientY <= 0) {
        setShowPopup(true);
        window.removeEventListener("mouseout", handleMouseOut);
      }
    };
    const isPopupShown = sessionStorage.getItem("exitPopup");

    if (isPopupShown) {
      return;
    }

    window.addEventListener("mouseout", handleMouseOut);

    return () => {
      window.removeEventListener("mouseout", handleMouseOut);
    };
  }, []);

  const handleClose = () => {
    setShowPopup(false);
    sessionStorage.setItem("exitPopup", "true");
  };

  return (
    <div className="layout-container">
      <Header
        formLink={props.formLink}
        fixAtTop={props.fixAtTop}
        pathname={props.pathname}
      />
      <div>{props.children}</div>
      <Footer />
      <KSLiveExitIntentPopup show={showPopup} handleClose={handleClose} />
      <LeadActivityTracker />
    </div>
  );
};

export default Layout;
